import { useAuth } from '../contexts/AuthContext';
import { hasRole } from '../services/auth';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';

const AppLayout = ({ children }) => {
  const { user } = useAuth();
  const isHost = hasRole(user, 'host');
  const isClient = hasRole(user, 'client');

  return (
    <div className={`min-h-screen flex flex-col ${
      isHost 
        ? 'bg-gradient-to-br from-emerald-50/40 via-white to-green-50/20' 
        : 'bg-gradient-to-br from-emerald-50/20 via-white to-green-50/10'
    }`}>
      <AppHeader />
      <main className="flex-1">
        {children}
      </main>
      <AppFooter />
    </div>
  );
};

export default AppLayout;

